import {
  action,
  computed,
  runInAction,
  makeObservable,
  observable,
  reaction,
} from 'mobx';
import { Services } from '@project/API';
import { SearchItem } from '../../API/resources/tableSearch';
import { Filter } from '../shared/LayersTree/Tree/Filter';
import { ResultNode } from './ResultNode';

const DEFAULT_QUERY = {
  _page_size: 10,
};

export class GlobalSearch {
  readonly filter: Filter;
  private _services: Services;
  @observable private _totalFeaturesCount: number | undefined = undefined;
  @observable private _error: string | undefined = undefined;
  @observable private _currentPageItems: ResultNode[] = [];
  @observable private _isLoading: boolean = false;

  constructor(services: Services) {
    this.filter = new Filter({ ...DEFAULT_QUERY });
    this._services = services;
    makeObservable(this);
    reaction(
      () => this.filter.query,
      () => this.loadData(),
    );
  }

  @computed get totalFeaturesCount() {
    return this._totalFeaturesCount;
  }

  @computed get error() {
    return this._error;
  }

  @computed get currentPageItems() {
    return this._currentPageItems;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @action reset = () => {
    this._error = undefined;
    this._totalFeaturesCount = undefined;
    this._currentPageItems = [];
  };

  @action loadData = async () => {
    runInAction(() => {
      this._error = undefined;
      this._totalFeaturesCount = undefined;
      this._isLoading = true;
      this._currentPageItems = [];
    });

    try {
      const { _page, _page_size } = this.filter.pagination;
      const query = this.filter.param;

      if (query._search === undefined) {
        throw new Error('Не удалось выполнить запрос');
      }

      const response = await this._services.tableSearch.list(
        query._search,
        _page,
        _page_size,
      );
      runInAction(() => {
        this._totalFeaturesCount = response._count;
        this._currentPageItems = response.features.map(
          (feature: SearchItem) => new ResultNode(feature),
        );
      });
    } catch (e) {
      this._error = 'Не удалось загрузить страницу';
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };
}
